import { useState } from 'react'
import Date from '../../../../Core/Fields/Floating/Date';
import Input from '../../../../Core/Fields/Floating/Input';
import Checkbox from '../../../../Core/Fields/Floating/Checkbox';
import Textarea from '../../../../Core/Fields/Floating/Textarea';
import SelectSearch from '../../../../Core/Fields/Floating/SelectSearch';
import { FiChevronDown } from 'react-icons/fi'
const Tab5 = ({
   pageState,setPageState,handleChange,onInputChange,
    taxId,setTaxId,
    settaxCategory,taxcategory,taxcatlist,
    taxwithholdlist,setTaxwithholds,taxwithholds,
    price, setPrice, pricelist,
    gst,setGst,setPan,pan,
    GstCategorylist,setGstCategory,gstCategory
}) => {

    const [isGroup, setIsGroup] = useState(0)


    return (
       <div>
      <div className="px-2 py-3" style={{ background: 'white' }}>
        <div style={{ display: 'flex' }} >
          <div className="col-md-6 px-2">
            <div className='' style={{ backgroundColor: '#EBE6FA', height: "100%", borderRadius: '4px', display: 'flex', flexDirection: 'column', width: '100%', padding: '10px' }}>
              <div style={{ display: 'flex', gap: '15px' }}>
                <div style={{ flex: 1 }}>
                  <p className='m-0' style={{ fontSize: '16px', fontWeight: '600' }}>Details</p>
                </div>
              </div>
              <div style={{ display: 'flex', gap: '15px' }}>
                 <div style={{ flex: 1 }}>
                    <Input
                            id="CustomerName"
                            label="Tax ID"
                            style={{ height: "30px" }}
                             value={pageState.taxId}
                    onChange={(e) => handleChange('taxId', e.target.value)}
                        />

                </div>
                <div style={{ flex: 1 }}>
                    <SelectSearch
                                list={taxcatlist || []}
                                label="Tax Category"
                                value={pageState.taxcategory}
                      onChange={(val) => handleChange('taxcategory', val)}
                               
                                getOptionLabel={(item) => item.name}
                                getOptionValue={(item) => item.name}
                                placeholder=""
                            />

                </div>
                <div style={{ flex: 1 }}>
                    <SelectSearch
                                list={taxwithholdlist || []}
                                label="Tax Withholding Category"
                                  value={pageState.taxwithholds}
                      onChange={(val) => handleChange('taxwithholds', val)}
                               
                               
                                getOptionLabel={(item) => item.name}
                                getOptionValue={(item) => item.name}
                                placeholder=""
                            />
                </div>
              </div>


            </div>
          </div>

          <div className="col-md-6 px-2">
            <div className='' style={{ backgroundColor: '#E3F5DF', height: "100%", borderRadius: '4px', display: 'flex', flexDirection: 'column', width: '100%', padding: '10px' }}>
              <div style={{ display: 'flex', gap: '15px' }}>
                <div style={{ flex: 1 }}>
                  <p className='m-0' style={{ fontSize: '16px', fontWeight: '600' }}>Tax Details</p>
                </div>
              </div>
              <div style={{ display: 'flex', gap: '15px' }}>

               <div style={{ flex: 1 }}>
                   <Input
                            id="GSTIN / UIN"
                            label="GSTIN / UIN"
                            style={{ height: "30px" }}
                            value={pageState.gst}
                    onChange={(e) => handleChange('gst', e.target.value)}
                        />
                </div>
                <div style={{ flex: 1 }}>
                 <Input
                            id="PAN"
                            label="PAN"
                            style={{ height: "30px" }}
                             value={pageState.pan}
                    onChange={(e) => handleChange('pan', e.target.value)}
                        />


                </div>
                <div style={{ flex: 1 }}>
                  <SelectSearch
                                list={GstCategorylist || []}
                                label="GST Category"
                                 value={pageState.gstCategory}
                      onChange={(val) => handleChange('gstCategory', val)}
                               
                             
                                getOptionLabel={(item) => item.name}
                                getOptionValue={(item) => item.name}
                                placeholder=""
                            />
                </div>

              </div>




            </div>
          </div>
        </div>
        
      </div>

    </div>

    )
}

export default Tab5